import React from 'react'
import { View, StyleSheet } from 'react-native'

import { colors, backgroundColors, radius } from '@sart/styles'
import client from '@sart/client'
import { useContent } from '@sart/content'



import {
  Label,
  Space,
  Button
} from '@sart/components'

import 'moment/locale/es-us'
import 'moment/locale/en-gb'

export default function CallToAction(props) {
  const {
    titleStyle,
    buttonTitleStyle,
    onPress,
    buttonStyle,
    disabledButtonStyle,
    disabled,
    text,
    buttonText,
    containerStyle,
    enableDismiss,
    dismissFunction,
  } = props

  const content = useContent()

  return (
    <View style={containerStyle ? containerStyle : styles.container}>
      {enableDismiss && (
        <Label
          onPress={dismissFunction}
          style={[
            titleStyle ? titleStyle : styles.label,
            {
              position: 'absolute',
              top: 12,
              right: 16,
              fontSize: 20,
              zIndex: 1,
            },
          ]}
        >
          ✕
        </Label>
      )}
      <Label style={titleStyle ? titleStyle : styles.label}>{text}</Label>

      <Space height={24} />

      <Button
        title={buttonText}
        onPress={onPress}
        titleStyle={buttonTitleStyle}
        style={buttonStyle}
        disabledStyle={disabledButtonStyle}
        disabled={disabled}
      />

      <Space height={12} />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 24,
    backgroundColor: backgroundColors.clear,
    borderRadius: radius.medium,
    elevation: 8,
    // ...shadows.shadowByElevation(8)
  },
  name: {
    fontSize: 32,
    lineHeight: 48,
    fontWeight: '700',
    color: colors.feature
  },
  row: {
    flexDirection: 'row',
  },
  column: {
    flex: 1,
    flexDirection: 'column',
  },
  label: {
    fontSize: 14,
    lineHeight: 24
  },
  text: {
    fontSize: 14,
    lineHeight: 24,
    color: colors.feature
  },
  cancel: {
    color: colors.trivial,
    textAlign: 'center'
  },
  error: {
    color: 'red',
  }
})
